import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Necesito experiencia previa en repostería?',
    a: '¡Para nada! El curso está diseñado desde cero. Te explicamos paso a paso cada receta, técnica y secreto para que te salgan perfectos desde el primer intento.'
  }, {
    q: '¿Cuánto puedo ganar vendiendo postres en vaso?',
    a: 'Depende de tu dedicación, pero los postres en vaso tienen un margen de ganancia excelente (suele ser del 100% al 200% sobre el costo). Muchos alumnos generan un sueldo extra trabajando solo los fines de semana.'
  }, {
    q: '¿Los ingredientes son caros o difíciles de conseguir?',
    a: 'No. Utilizamos ingredientes accesibles que podés encontrar en cualquier supermercado o cotillón de tu barrio. La clave está en la combinación y presentación, no en gastar fortunas.'
  }, {
    q: '¿Tengo acceso de por vida al curso?',
    a: '¡Sí! Una vez que comprás, el acceso es tuyo para siempre. Podés ver los videos las veces que quieras, pausarlos, retroceder y aprender a tu propio ritmo.'
  }, {
    q: '¿Hay algún tipo de garantía?',
    a: 'Sí, tenés 30 días de garantía de satisfacción. Si comprás el curso, lo mirás y sentís que no es para vos, te devolvemos el 100% de tu dinero sin hacer preguntas.'
  }, {
    q: '¿Cómo recibo el curso una vez que pago?',
    a: 'El acceso es inmediato. Apenas se aprueba tu pago, te llega un email con tu usuario y contraseña para ingresar a la plataforma y empezar a ver las clases en ese mismo instante.'
  }];
  return <section className="py-20 bg-[#0d0906]" data-id="element-13">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-14">
        <div className="text-center mb-12" data-id="element-15">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-16">
            Preguntas <span className="text-[#d4a843]" data-id="element-17">Frecuentes</span>
          </h2>
          <p className="text-[#c9b99a]" data-id="element-18">
            Resolvemos todas tus dudas antes de empezar.
          </p>
        </div>

        <div className="space-y-4" data-id="element-19">
          {faqs.map((faq, index) => <div key={index} className="glass-card overflow-hidden transition-all duration-300" data-id="element-20">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-21">
                <span className="text-lg font-semibold text-white pr-4" data-id="element-22">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#d4a843] transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-23" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-24">
                <p className="text-[#c9b99a] leading-relaxed" data-id="element-25">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}